export default __webpack_public_path__ + "static/media/secret_pay.877a1891.svg";